export const BASE_FONT_SIZE = 10;

export const MAX_IDLE_TIME = 1000 * 60 * 60 * 6; // 6 hours
